import {Component, Input, ViewEncapsulation} from '@angular/core';
import {HttpService} from '../../../services/http.service';
import {AuthService} from '../../../auth/auth.service';
import {I18nPipe} from '../../../services/i18n.pipe';
import {SweetUtil} from '../../commons/sweet/sweet-util-service';
import {FileTypeVerifierPipe} from '../../../services/filetype-verifier.pipe';

@Component({
  selector: 'app-admin-warranty-conditions',
  templateUrl: './admin-warranty-conditions.component.html',
  styleUrls: ['./admin-warranty-conditions.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AdminWarrantyConditionsComponent {
  @Input() folderFiles: string[] = [];
  @Input() folderName: string;
  pdfFiles: string[] = [];
  nonPdfFiles: string[] = [];

  constructor(private http: HttpService, private authService: AuthService, private i18nPipe: I18nPipe,
              private sweetUtil: SweetUtil, private fileTypeVerifierPipe: FileTypeVerifierPipe) {
  }

  reload() {
    window.location.reload();
  }

  downloadWarrantyConditions(folder: string, filenameAndExtension: string) {
    this.http.downloadWarrantyConditionBooklet(folder, filenameAndExtension);
  }

  deleteFile(folder: string, filenameAndExtension: string) {
    this.sweetUtil.getConfirmTranslated('delete', 'warranty-condition-file-delete')
      .then((res) => {
      if (res.value) {
        this.http.deleteWarrantyConditionBooklet(folder, filenameAndExtension).subscribe((r: any) => {
            this.sweetUtil.showSuccessTranslated('success', 'warranty-condition-file-delete-success').then(() => {
              this.reload();
            });
        }, err => {
            this.sweetUtil.showError('warranty-condition-file-delete-err').then();
        });
      }
    });
  }

  /**
   * on file drop handler
   */
  onFileDropped($event: File[]) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files: File[]) {
    this.prepareFilesList(files);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  async prepareFilesList(files: Array<File>) {
    const formData = new FormData();
    for (const item of files) {
      const isFileTypeGenuine = await this.fileTypeVerifierPipe.transform(item);
      if (isFileTypeGenuine && item.type === 'application/pdf') {
        formData.append('file', item, item.name);
        this.pdfFiles.push(item.name);
      } else {
        this.nonPdfFiles.push(item.name);
      }
    }
    if (this.nonPdfFiles.length > 0) {
      this.sweetUtil.showError('warranty-condition-file-err', 'warranty-condition-file-err-title').then();
    } else if (formData.getAll('file').length > 0) {
      // check for duplicate files for replacement
      const listReplacedFiles = this.checkExistingFiles();
      if (listReplacedFiles.length > 0) {
        this.sweetUtil.getConfirmTranslated('replace', this.i18nPipe.transform('',
          `${this.i18nPipe.transform('', 'warranty-condition-upload-replace-confirm-a')}<br>
          ${listReplacedFiles.join(',<br>')}<br>
          ${this.i18nPipe.transform('', 'warranty-condition-upload-replace-confirm-b')}`)).then((res) => {
          if (res.value) {
            this.confirmAndPostFiles(formData, 'success', 'warranty-condition-upload-replace-success', 'update');
          } else {
            this.reload();
          }
        });
      } else {
        this.confirmAndPostFiles(formData);
      }
    }
    this.pdfFiles = [];
    this.nonPdfFiles = [];
  }

  /**
   * @param formData
   * @param dialogHeader
   * @param dialogMessage
   * @param action
   */
  confirmAndPostFiles(formData: FormData, dialogHeader = 'success',
                      dialogMessage = 'warranty-condition-file-success', action = 'save') {
    if (action === 'save') {
      this.sweetUtil.getConfirmTranslated('upload', 'warranty-condition-file-confirm').then((res) => {
        if (res.value) {
          this.postFiles(formData, dialogHeader, dialogMessage);
        }
      });
    } else {
      this.postFiles(formData, dialogHeader, dialogMessage);
    }
  }

  /**
   * post files
   * @param formData FormData
   * @param dialogHeader
   * @param dialogMessage
   */
  postFiles(formData: FormData, dialogHeader: string, dialogMessage: string) {
    this.http.postWarrantyConditions(this.folderName, formData).subscribe((res) => {
      this.sweetUtil.showSuccessTranslated(dialogHeader, dialogMessage).then(() => {
        this.reload();
      });
    }, err => {
      if (err.status === 406) {
        console.error(`Error returned ${err}`);
        this.sweetUtil.showError('warranty-condition-file-406-err').then();
      } else {
        console.error(err);
        this.sweetUtil.showError('warranty-condition-file-other-err').then();
        console.error(`Error return ${JSON.stringify(err)}`);
      }
    });
  }

  isAdmin(): boolean {
    return this.authService.isAdmin();
  }

  isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }

  checkExistingFiles(): Array<string> {
    return this.intersect(this.folderFiles, this.pdfFiles);
  }

  /**
   * @param x
   * @param y
   */
  intersect = (x, y) => {
    const setY = new Set(y);
    return x.filter(element => setY.has(element));
  }
}
